import { IssueState } from '../types/issue-state';

export const isStatusAvailable = (
  newStatus: IssueState,
  currentStatus?: IssueState,
) => {
  if (!currentStatus) return false;

  switch (currentStatus) {
    case 'NEW': {
      switch (newStatus) {
        case 'NEW':
          return false;

        case 'IN_PROGRESS':
          return true;

        case 'RESOLVED':
          return false;

        case 'REJECTED':
          return true;
      }

      break;
    }

    case 'IN_PROGRESS': {
      switch (newStatus) {
        case 'NEW':
          return false;

        case 'IN_PROGRESS':
          return false;

        case 'RESOLVED':
          return true;

        case 'REJECTED':
          return true;
      }

      break;
    }

    case 'RESOLVED': {
      switch (newStatus) {
        case 'NEW':
          return false;

        case 'IN_PROGRESS':
          return false;

        case 'RESOLVED':
          return false;

        case 'REJECTED':
          return false;
      }
      break;
    }

    case 'REJECTED': {
      switch (newStatus) {
        case 'NEW':
          return false;

        case 'IN_PROGRESS':
          return false;

        case 'RESOLVED':
          return false;

        case 'REJECTED':
          return false;
      }
    }
  }
};
